import { ApexApiError } from 'apex-ui-services'
import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { UseToastOptions } from '@chakra-ui/react'
import { isEmpty } from 'lodash'
import {
  getCaseStatus,
  putCaseAccept,
  putCaseReject,
} from '../api/acatsCaseApi'
import { HttpResponseStatusCodes } from '../constants'
import {
  CASE_ACCEPT_FAILED,
  CASE_REJECT_FAILED,
  CASE_RETRIEVAL_FAILED,
  TEMPORARILY_UNAVAILABLE,
} from './constants'
import { ResolutionResultDto, ValidationErrorWebDto } from '../api/types'

export const GET_CASE_STATUS = 'CASE_STATUS'
export const GET_CASE_STATUS_SUCCESS = 'CASE_STATUS_SUCCESS'
export const GET_CASE_STATUS_FAILURE = 'CASE_STATUS_FAILURE'

export const PUT_CASE_ACCEPT = 'PUT_CASE_ACCEPT'
export const PUT_CASE_ACCEPT_SUCCESS = 'PUT_CASE_ACCEPT_SUCCESS'
export const PUT_CASE_ACCEPT_FAILURE = 'PUT_CASE_ACCEPT_FAILURE'

export const DELETE_CASE_REJECT = 'DELETE_CASE_REJECT'
export const DELETE_CASE_REJECT_SUCCESS = 'DELETE_CASE_REJECT_SUCCESS'
export const DELETE_CASE_REJECT_FAILURE = 'DELETE_CASE_REJECT_FAILURE'

export const caseStatus = (dispatch: Dispatch, acatId: string) => {
  dispatch({ type: GET_CASE_STATUS })
  getCaseStatus(acatId)
    .then((response: AxiosResponse) => {
      const { data } = response
      dispatch({ type: GET_CASE_STATUS_SUCCESS, caseStatusResults: data })
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      const errorMessage =
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
          ? TEMPORARILY_UNAVAILABLE
          : CASE_RETRIEVAL_FAILED
      dispatch({ type: GET_CASE_STATUS_FAILURE, errorMessage })
    })
}

const callSuccessToast = (
  toast: (props: UseToastOptions) => void,
  data: ResolutionResultDto
) => {
  if (!isEmpty(data.errors)) {
    data.errors.forEach((error: ValidationErrorWebDto) =>
      toast({
        title: 'Error',
        description: error.message,
        status: 'error',
      })
    )
  } else {
    toast({
      title: 'Success',
      description: 'The transfer was completed successfully.',
      status: 'success',
      isClosable: true,
    })
  }
}

const callErrorToast = (
  toast: (props: UseToastOptions) => void,
  errorMessage: string
) => {
  toast({
    title: 'Error',
    description: errorMessage,
    status: 'error',
  })
}

export const caseAccept = (
  dispatch: Dispatch,
  processingCaseId: number,
  toast: (props: UseToastOptions) => void
) => {
  dispatch({ type: PUT_CASE_ACCEPT })
  putCaseAccept(processingCaseId)
    .then((response: AxiosResponse) => {
      const { data } = response
      dispatch({ type: PUT_CASE_ACCEPT_SUCCESS, caseCompletionResults: data })
      callSuccessToast(toast, data)
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      const errorMessage =
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
          ? TEMPORARILY_UNAVAILABLE
          : CASE_ACCEPT_FAILED
      dispatch({ type: PUT_CASE_ACCEPT_FAILURE, errorMessage })
      callErrorToast(toast, errorMessage)
    })
}

export const caseReject = (
  dispatch: Dispatch,
  processingCaseId: number,
  reason: string,
  comment: string,
  toast: (props: UseToastOptions) => void
) => {
  dispatch({ type: DELETE_CASE_REJECT })
  putCaseReject(processingCaseId, reason, comment)
    .then((response: AxiosResponse) => {
      const { data } = response
      dispatch({
        type: DELETE_CASE_REJECT_SUCCESS,
        caseCompletionResults: data,
      })
      callSuccessToast(toast, data)
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      const errorMessage =
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
          ? TEMPORARILY_UNAVAILABLE
          : CASE_REJECT_FAILED
      dispatch({ type: DELETE_CASE_REJECT_FAILURE, errorMessage })
      callErrorToast(toast, errorMessage)
    })
}
